import { useMemo } from 'react';

export function useListingCancellation(cancellation) {
  return useMemo(() => {
    if (!cancellation) {
      return ['', ''];
    }
    return [
      CANCELLATIONS[cancellation].label,
      CANCELLATIONS[cancellation].tooltip,
    ];
  }, [cancellation]);
}

const CANCELLATIONS = {
  last_minute: {
    label: app_main_wpml.last_minute,
    tooltip: app_main_wpml.last_minute_tooltip,
  },
  very_flexible: {
    label: app_main_wpml.very_flexible,
    tooltip: app_main_wpml.very_flexible_tooltip,
  },
  flexible: {
    label: app_main_wpml.flexible,
    tooltip: app_main_wpml.flexible_tooltip,
  },
  moderate: {
    label: app_main_wpml.moderate,
    tooltip: app_main_wpml.moderate_tooltip,
  },
  strict: {
    label: app_main_wpml.strict,
    tooltip: app_main_wpml.strict_tooltip,
  },
  very_strict: {
    label: app_main_wpml.very_strict,
    tooltip: app_main_wpml.very_strict_tooltip
  },
};
